import { IResponse } from "models";

export enum ActionType {
  VERIFY_RESET_TOKEN = "action/VERIFY_RESET_TOKEN",
  VERIFY_RESET_TOKEN_SUCCESS = "action/VERIFY_RESET_TOKEN_SUCCESS",
  VERIFY_RESET_TOKEN_ERROR = "action/VERIFY_RESET_TOKEN_ERROR",
  RESET_VERIFY_RESET_TOKEN = "action/RESET_VERIFY_RESET_TOKEN",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface VerifyResetPasswordTokenData {
  reset_password_token: string;
}

export interface VerifyResetPasswordTokenResponse extends IResponse {}
